<template>
    <div>
        <!--公共创建班级-->
        <common-dialog  @closeDialog="closeDialog"  :dialogShow.sync="createTeachingDialogVisible" :model-obj="dialogModelObj">
            <el-form ref="dynamicValidateForm" :model="form" width="500" label-width="120px">
                <el-form-item label="所属学校"  >
                    {{form.schoolName}}
                </el-form-item>
                <el-form-item label="选择年级" :rules="{ required: true, message: '请选择年级', trigger: 'blur' }" prop="gradeValue">
                    <el-select size="small" v-model="form.gradeValue" @change="selectGrade" placeholder="请选择年级">
                        <el-option :label="item.gradeName" :value="item.gradeYear" v-for="item in form.grade" :key="item.gradeYear"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-show="this.changeClassType===2" label="关联学科" prop="subjectValue" :rules="{ required: true, validator:checkSubject, trigger: 'blur' }">
                    <el-select size="small" v-model="form.subjectValue" @change="selectSubject" placeholder="请选择学科">
                        <el-option :label="item.subjectName" v-for="item in form.subjectList"
                                   :key="item.subjectId"  :value="item.subjectId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="班级命名模式" prop="selectModel">
                    <el-radio-group v-model="form.selectModel">
                        <el-radio v-for="item in form.nameMode" @change="selectClassNameType"
                                  :key="item.type" :label="item.type">
                            {{item.typeName}}
                        </el-radio>
                    </el-radio-group>
                    <div class="text-medium-secondary text-s-size padding-right" style="line-height: 20px;">
                        {{descFirst}}
                        <p>{{descSecond}}</p>
                    </div>
                </el-form-item>
                <el-form-item label="班级号" :rules="{ required: true, message: '不能为空', trigger: 'blur' }" prop="className">
                    {{form.selectModel===1&&changeClassType===2?
                    getSelectSubject+'教学':form.selectModel===1&&changeClassType===1?
                    getSelectGrade:''}}
                    <span v-show="form.selectModel===1">
                        （<el-input size="small" v-model="form.className"></el-input>）班
                    </span>
                    <span v-show="form.selectModel===2">
                        <el-input size="small" v-model="form.className" placeholder="不超过10个字" :maxlength="10"></el-input>
                    </span>
                </el-form-item>
                <el-form-item label="学生加班设置" prop="addClassSetting">
                    <el-select size="small" v-model="form.addClassSetting" placeholder="请输入班级号">
                        <el-option :label="item.text" :value="item.allowUserJoinValue" v-for="item in form.jbSettingList" :key="item.allowUserJoinValue"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="允许学生改名">
                    <el-switch
                            v-model="form.allowStudentChangeValue"
                            active-color="#13ce66"
                            active-text="允许改名"
                            inactive-text="禁止改名">
                    </el-switch>
                </el-form-item>
                <el-form-item class="text-center">
                    <el-button size="small" @click="createTeachingDialogVisible = false">关闭</el-button>
                    <el-button size="small" type="primary" @click="confirmCreateClass('dynamicValidateForm')">确 定</el-button>
                </el-form-item>
            </el-form>
            <div  class="dialog-footer padding-y text-center">

            </div>
        </common-dialog>

    </div>
</template>

<script>
    import {createClassInfo, createClassroom} from "../../../../config";
    import {message} from 'element-ui'
    export default {
        name: "commonCreateClass",
        data(){
            var checkSubject=(rule,value,callback)=>{
                if(this.changeClassType===2&&!value){
                    return callback(new Error('请选择学科'));
                }else{
                    callback();
                }
            };
            return{
                checkSubject:checkSubject,
                //区分是行政班为1还是教学班为2
                changeClassType:'',
                createTeachingDialogVisible:false,
                dialogModelObj:{
                    width:"708px",
                    title:'创建班级'
                },
                /******获取创建班级的相关信息******/
                form:{
                    //控制是否允许学生改名
                    allowStudentChangeValue:true,
                    //设置加班的值
                    addClassSetting:'',
                    //所属学校
                    schoolName:'',
                    //选择年级
                    grade:[],
                    gradeValue:'',
                    //关联学科
                    subjectList:[],
                    //班级命名模式
                    nameMode:[],
                    selectModel:'',
                    className:'',
                    subjectValue:'',
                    //学生加班选择列表
                    jbSettingList:[],
                    //是否允许学生改名
                    studentChangeAllowed:'开'
                },
                descSecond:'',
                descFirst:'',
                //获取选择的学科
                getSelectSubject:'',
                getSelectGrade:''

            }
        },
        methods:{
            //选择年级
            selectGrade(val){
                let zhi= this.form.grade.filter((valSmall)=>{
                    return val===valSmall.gradeYear;
                })
                console.log(zhi);
                this.getSelectGrade=zhi[0].gradeSimpleName
                console.log(this.getSelectGrade);
            },
            selectSubject(val){
               let zhi= this.form.subjectList.filter((smallVal)=>{
                    return smallVal.subjectId===val;
                })

                this.getSelectSubject=zhi[0].subjectName;
                console.log(this.getSelectSubject);
            },
            //选择班级命名模式
            selectClassNameType(val){
                console.log(val);
                if(val===1){
                //选择班级号命名
                    console.log(val);
                }else{
                //自定义命名

                }
            },
            //创建班级基础内容
            async createClassroom(val){
                // val等于1是行政班，2是教学班
                this.changeClassType=val;
                this.createTeachingDialogVisible=true;
                let result=await createClassInfo();
                if(result.status){
                    console.log(result.data);
                    this.descFirst=result.data.descFirst;
                    this.descSecond=result.data.descSecond;
                    this.form.schoolName=result.data.schoolName;
                    this.form.grade=result.data.gradeSelect;
                    this.form.subjectList=result.data.subjectSelect;
                    this.form.nameMode=result.data.type;
                    this.form.selectModel=result.data.type[0].type;
                    this.form.jbSettingList=result.data.allowUserJoinValues;
                    this.form.addClassSetting=result.data.allowUserJoinValues[0].allowUserJoinValue;

                }
            },
            closeDialog(){
                this.createTeachingDialogVisible=false;
            },
            //确定创建班级
            confirmCreateClass(form){
                let reg=/^\d*$/;

                this.$refs['dynamicValidateForm'].validate((valid)=>{
                    if(this.form.selectModel===1&&!reg.test(this.form.className)){
                        message({
                            message:'班级名称格式不正确',
                            type:'warning',
                            offset:200
                        })
                        return false;
                    }else{

                    }
                    if(!valid){
                        return false;
                    }
                    this.createClass();

                })
            },
            //创建教学班接口
            async createClass(){
                let zhi=0;
                //获取是否允许学生改名的值
                if(this.form.allowStudentChangeValue){
                    zhi=1;
                }else{
                    zhi=0;
                }
                let className='';
                //如果是教学班


                let result=await createClassroom(this.changeClassType,
                    this.form.selectModel,this.form.gradeValue,
                    this.form.className,
                    this.form.subjectValue,
                    this.form.addClassSetting,zhi);
                if(result.status){
                    this.createTeachingDialogVisible=false;
                    message({
                        message:this.changeClassType===1?'行政班创建成功':'教学班创建成功',
                        type:'success',
                        offset:200

                    })
                    this.$emit('searchClassroomList');
                }else{

                }
            },
        }
    }
</script>

<style scoped>

</style>